import { useCallback } from 'react';
import { useSetAtom } from 'jotai';

import { toastAtom } from '../atoms';
import type { ToastSeverity } from '../atoms';

// Result of an action (removal, rejection, update…): shown in the toast at the top right.
const usePageMessage = () => {
  const setToast = useSetAtom(toastAtom);

  const showMessage = useCallback((text: string, severity: ToastSeverity = 'success') => {
    setToast({ id: Date.now(), text, severity });
  }, [setToast]);

  const closeMessage = useCallback(() => {
    setToast(null);
  }, [setToast]);

  return {
    closeMessage,
    showMessage,
  };
};

export default usePageMessage;
